import { Component, EventEmitter, Output } from "@angular/core";
import { JoinUrl } from "src/app/constants/url/join.url";
import { LoginUrl } from "src/app/constants/url/login.url";
import { ResponseDto } from "src/app/dto/common/response.dto";
import { JoinDto } from "src/app/dto/join/join.dto";
import { HttpService } from "src/app/service/http/http.service";
import { RsaUtil } from "src/app/utils/rsa.util";
import { JoinValidator } from "./join.validator";

@Component({
    selector: 'info',
    templateUrl: '../../view/join/info.html'
})
export class InfoComponent {
    private publicKey!: string;

    public joinValidator: JoinValidator = new JoinValidator();
    public joinDto: JoinDto = new JoinDto();
    public passwordConfirm!: string;

    @Output() public cancelEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() public nextEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private httpService: HttpService) {
        this.getPublicKey();
    }

    private getPublicKey(): void {
        this.httpService.get<ResponseDto<string>>(LoginUrl.publicKey)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.publicKey = response.data;
                }
            });
    }

    private encryptPassword(): boolean {
        let encryptedPassword: string | false = RsaUtil.encrypt(this.publicKey, this.joinDto.password);
        if (encryptedPassword) {
            this.joinDto.password = encryptedPassword;
            return true;
        }

        return false;
    }

    public cancel(): void {
        this.cancelEvent.emit();
    }

    public next(): void {
        if (this.joinValidator.isValid() && this.encryptPassword()) {
            this.httpService.post<ResponseDto<void>>(JoinUrl.join, this.joinDto)
                .subscribe(response => {
                    if (response.isSuccess) {
                        this.nextEvent.emit(this.joinDto.email);
                    }
                });
        }
    }
}